import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';

class LeaveReportController {
  constructor($rootScope, $uibModal, $state, $http) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.queryResult;
    this.$rootScope = $rootScope;
    this.formatCurrency = formatCurrency;

    let self = this;


    self.queryParams = {
      year: {
        name: 'year',
        value: moment().year() + ''
      },
      endDate: {
        name: 'endDate',
        value: moment().format("yyyy-MM-DD")
      },
      leaveType: {
        name: 'leaveType',
        value: 'PTO'
      }
    };

    // this.$http.get(this.$rootScope.apiHost+"/api/reports/yearlyhoursreport", {withCredentials: true}).then(function (success) {
    //   self.report = success.data;
    //   self.queryParams = self.report.filterParameters;
    //
    //   self.queryParams = {
    //     year: {
    //       name: 'year',
    //       value: moment().year() + ''
    //     },
    //     endDate: {
    //       name: 'endDate',
    //       value: moment().format("yyyy-MM-DD")
    //     },
    //     leaveType: {
    //       name: 'leaveType',
    //       value: 'PTO'
    //     }
    //   };
    //
    //   self.search();
    // });

    self.leaveTypes = [];
    this.$http.get($rootScope.apiHost+"/api/leave/types", {withCredentials: true}).then(function (success) {
      self.leaveTypes = success.data;
    });

    this.opened = {};
    this.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      self.opened[elementOpened] = !self.opened[elementOpened];
    };

    this.datePickerFormat = 'MMM dd, yyyy';
    this.datePickerOptions = {
      formatYear: 'yyyy',
      formatMonth: 'MMM',
      formatDay: 'dd',
      // maxDate: new Date(2020, 5, 22),
      minDate: new Date(1999,1,1),
      startingDay: 1
    };

  }


  search() {
    let self = this;

    this.queryParams.endDate.value.setHours(0);
    this.queryParams.endDate.value.setMinutes(0);
    this.queryParams.endDate.value.setSeconds(0);
    this.queryParams.endDate.value.setMilliseconds(0);



    this.$http.post(this.$rootScope.apiHost+"/api/reports/leavereport", this.queryParams, {withCredentials: true}).then(function (success) {
      self.queryResult = success.data;
    });
  }




}

export default LeaveReportController;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/leave-report/leave-report.controller.js